// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__qWJTS","hosts":"footer_hosts__lIgYJ","partnerLogo":"footer_partnerLogo__9TLAo","container":"footer_container__15Dvp","section":"footer_section__lqrgw"};